import theme from 'src/theme';
import styled from 'styled-components';

export const UndoContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 0.5rem;

    svg {
        ${(props) => props.theme.clickableIcon};
    }
`;

export const StowagePlanItemWrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(20px, 20px) minmax(260px, 1fr) minmax(20px, 20px);
`;

export const StowagePlanItemSubWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left; !important;
    padding-left: 10px;
`;

export const StowagePlanListGroup = styled.li`
    max-height: 600px;
    overflow-y: auto;
`;

export const StowagePlanListItemTitle = styled.div`
    flex: 1;
    font-weight: bold;
    width: 100%;
`;

export const StowagePlanListItemSubtitle = styled.div`
    flex: 1;
    width: 100%;
`;

export const ReportOptionWrapper = styled.div<{
    disabled?: boolean;
}>`
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    padding: 2px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${theme.colors.background.hover.default};
    }
`;

export const ReportOptionCheckbox = styled.input<{
    disabled?: boolean;
}>`
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const ReportOptionIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    color: ${theme.colors.text.heading};

    .icon {
        margin: 0 4px 0 2px;
        font-size: 1rem;
    }
`;

export const ReportOptionDescriptionText = styled.span`
    color: ${theme.colors.text.blueLink};
    font-size: 12px;
    flex: 1;
`;
